import * as React from 'react';
/**
 *
 * Original name: puzzle piece
 *
 * Figma URL: https://www.figma.com/file/RPY7Gy4EixfwdOtVIf2PaX/_Global---Icons?node-id=29162%3A6715
 *
 */
export const PuzzlePieceFill = (props) => (React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.333 10.912H16.8V7.19h-3.733v-.532C13.067 4.944 12.119 4 10.4 4c-1.719 0-2.66.944-2.66 2.658v.532H4V20h4.083v-2.177c0-1.71.698-1.99 2.417-1.99 1.719 0 2.167.276 2.167 1.99V20H16.8v-3.777h.533c1.72 0 2.667-1.013 2.667-2.723s-.948-2.588-2.667-2.588Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" })));
